export default __webpack_public_path__ + "static/media/menu-tile-stigma.ce3fdaf0.png";